import { render, staticRenderFns } from "./NomTipDoc.vue?vue&type=template&id=4ed8f002&scoped=true&"
import script from "./NomTipDoc.ts?vue&type=script&lang=ts&"
export * from "./NomTipDoc.ts?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4ed8f002",
  null
  
)

export default component.exports
import {QTable,QBtn,QTooltip,QSpace,QInput,QIcon,QTh,QTr,QTd,QDialog,QCard,QBar,QCardSection,ClosePopup} from 'quasar'
component.options.components = Object.assign({QTable,QBtn,QTooltip,QSpace,QInput,QIcon,QTh,QTr,QTd,QDialog,QCard,QBar,QCardSection}, component.options.components || {})
component.options.directives = Object.assign({ClosePopup}, component.options.directives || {})
